import React from "react";
import { Toggle, RaisedButton, TextField } from "material-ui";

class CookiePreferences extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      advertisingPref: true,
      analyticsPref: true,
      performancePref: true
    };
  }

  componentDidMount() { 
    if (window && window.CookieConsent) {
      //short delay seems to fix an issue with the popup not showing
      setTimeout(function() {
        window.CookieConsent.showPreferences();
      }, 200);
    }
  }

  getStyles() {
    return {
      container: {
        margin: "40px auto",
        maxWidth: 300,
        textAlign: "center"
      },
      button: {
        marginTop: 30
      },
      toggle: {
        width: 300,
        marginBottom: 5,
        textAlign: "left"
      },
      code: {
        width: 300
      }
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired
    };
  }

  render() {
    var styles = this.getStyles();

    return (
      <div style={styles.container}>

        <div style={{ fontSize: 18, paddingBottom: 10 }}>Cookie Privacy Preferences</div>

        <RaisedButton
          primary
          label="Manage cookie preferences"
          style={styles.button}
          onClick={() => {
            if (window && window.CookieConsent) {
              window.CookieConsent.showPreferences();
            }
          }}
        />

        <div style={{ width: 10, height: 40 }}></div>

        <RaisedButton
          label="Return to schedule"
          style={styles.button}
          onClick={() => this.context.router.push("/schedule")}
        />
      </div>
    );
  }
}

export default CookiePreferences;



// WEBPACK FOOTER //
// ./src/app/components/cookie-preferences.jsx